export const style = {
  section: {
    background: `#f5f3f4`
  },
  h2: {
    fontSize: `2.2rem`,
    fontWeight: 300,
    lineHeight: `42px`,
    margin: `0 0 32px 0`
  },
  h2InnerTitle: {
    fontWeight: `bold`
  },
  p: {
    marginBottom: `20px`,
    fontSize: `16px`,
    fontWeight: 300,
    lineHeight: `1.4`,
    color: `#666`,
    '@media (min-width: 768px)': {
      fontSize: `21px`
    }
  },
  pSecondary: {
    marginBottom: `20px`,
    fontSize: `14px`,
    lineHeight: `1.4`,
    color: `#666`
  },
  image: {
    maxWidth: `100%`,
    height: `auto`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Home/style/mission.js